import cx from 'classnames'
import PropTypes from 'prop-types'
import styles from './ShortDescriptionField.css'

import { Field } from '../../../../Common/forms'
import {
  InputCountField
} from '../../../../Common/Form'
import {
  validateRequiredProductShortDescription,
  validateNotRequiredProductShortDescription
} from '../Shared/validation/fieldLevelValidator'
import { filterHtmlTagAndSpace } from '../Shared/normalizers'
import Tip from '../../Tip'
import SingleLineText from '../../ReadOnlyComponents/SingleLineText/SingleLineText'

const getBaseFieldProps = (idx) => {
  return {
    validate: idx === 0 ? validateRequiredProductShortDescription : validateNotRequiredProductShortDescription,
    placeholder: idx === 0 ? '必填' : '非必填',
    normalizeOnBlur: filterHtmlTagAndSpace
  }
}

const ShortDescriptionItemField = (props) => {
  const { input, readOnly } = props
  const Comp = readOnly ? SingleLineText : InputCountField
  return readOnly ? input.value ? <li><Comp {...props} /></li> : null : <li><Comp {...props} /></li>
}

const ShortDescriptionField = (props) => {
  const { countLimit, readOnly, fields, showErrorOnActive, mustShowFormError } = props
  const elements = fields.map((fieldName, idx, fields) => {
    return (
      <Field
        key={idx}
        data-role={`${props['data-role']}-${idx}`}
        name={fieldName}
        readOnly={readOnly}
        countLimit={countLimit}
        component={ShortDescriptionItemField}
        showErrorOnActive={showErrorOnActive}
        mustShowFormError={mustShowFormError}
        {...getBaseFieldProps(idx)}
      />
    )
  })
  return (
    <>
      {!readOnly && (
        <Tip
          key='tip'
          type='info'
        >
          至少一行，至多五行。充分利用內容說明產品最相關的促購與特色重點;
          <br />
          亦可放入次要關鍵字、相關字與同義字等，增加曝光可能性。
        </Tip>
      )}
      <ul
        key='field'
        className={cx(styles.ShortDescriptionField, {
          [styles.readOnly]: !!readOnly
        })}
      >
        {elements}
      </ul>
    </>
  )
}

ShortDescriptionField.propTypes = {
  readOnly: PropTypes.bool
}

ShortDescriptionField.defaultProps = {
  readOnly: false
}

export default ShortDescriptionField
